import Menu from './Compartido/Menu.jsx';
import DatosCliente from './CompartidoUsuario/DatosCliente.jsx'
import Footer from './Compartido/Footer.jsx';

const MiPerfil = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <DatosCliente
                lang={props.lang}
                config={props.config}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default MiPerfil;
